<template>
  <a @click="qrScud($event)">
    <img :src="iconPath('v_scud.svg')" alt="" class="icon-pdf">
    QR-код посетителя
  </a>
</template>

<script>
import mainMixin from '@/common/mixins/mainMixin'
import actionListMenuMixin from '@/common/mixins/actionListMenuMixin'

export default {
  name: 'QrScudButton',

  mixins: [
    mainMixin,
    actionListMenuMixin
  ],

  props: {
    personalId: Number
  },

  methods: {
    iconPath(baseName) {
      return require('@/common/assets/img/icons/menuVisitor/' + baseName)
    }
  }
}
</script>
